var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.params.organizationId)?_c('mol-header'):_vm._e(),_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1),_c('mol-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }